import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { AnnualInsurance } from '../../shared/models/quotation-model/catalogs/annual-insurance.model';
import { Brand } from '../../shared/models/quotation-model/catalogs/brand.model';
import { Coverage } from '../../shared/models/quotation-model/catalogs/coverage.model';
import { DeadLine } from '../../shared/models/quotation-model/catalogs/dead-line.model';
import { InsurancePayment } from '../../shared/models/quotation-model/catalogs/insurance-payment.model';
import { Insurance } from '../../shared/models/quotation-model/catalogs/insurance.model';
import { VehicleUse } from '../../shared/models/quotation-model/catalogs/vehicle-use.model.model';
import { QuotationComparative } from '../../shared/models/quotation-model/main/quotation-comparative.model';
import { QuotationCompareCoverages } from '../../shared/models/quotation-model/main/quotation-compare-coverages.model';
import { QuotationCompareDeadLines } from '../../shared/models/quotation-model/main/quotation-compare-deadlines.model';
import { QuotationEditFinalValues } from '../../shared/models/quotation-model/main/quotation-edit-final-values.model';
import { QuotationEditModel } from '../../shared/models/quotation-model/main/quotation-edit-model';
import { QuotationFinancialValues } from '../../shared/models/quotation-model/main/quotation-financial-values.model';
import { AnnualInsuranceService } from '../../shared/services/quotation/catalogs/annual-Insurance.service';
import { InsurancePaymentService } from '../../shared/services/quotation/catalogs/insurance-payment.service';
import { VehicleUseService } from '../../shared/services/quotation/catalogs/vehicle-use.service';
import { QuotationService } from '../../shared/services/quotation/quotation.service';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { NgxMaskDirective } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption, MatSelectModule } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { GeneralService } from '../../shared/services/general.service';

@Component({
  selector: 'app-premises-section',
  templateUrl: './premises-section.component.html',
  styleUrls: ['./premises-section.component.scss'],
  standalone: true,
  imports: [
    MatFormField,
    MatFormFieldModule,
    MatLabel,
    NgxMaskDirective,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatOption,
    MatIcon,
    MatTooltipModule,
    MatCheckbox,
    MatInputModule,
    MatSelectModule,
    CommonModule,
    MatButtonModule,
  ],
})
export class PremisesSectionComponent implements OnInit, OnDestroy {
  @Input() quotationId!: number;
  @Input() ticketId!: number;
  @Input() selectedDeadLines!: DeadLine[];
  @Input() selectedCoverages!: Coverage[];
  @Input() selectedBrand!: Brand;
  @Input() selectedProgram!: Insurance;
  @Output() comparativeComponentReturn = new EventEmitter<any>();

  hasQuotation!: boolean;
  vehicleUses: VehicleUse[] = [];
  insurancePayments: InsurancePayment[] = [];
  annualInsurances: AnnualInsurance[] = [];
  deadLinesCompare!: QuotationCompareDeadLines[];
  coveragesCompare!: QuotationCompareCoverages[];
  //Información para el comparativo
  selectedDeadline!: DeadLine;
  quotationComparatives: QuotationComparative[] = [];
  selectedQuotationComparative!: QuotationComparative;
  quotationFinancialValues!: QuotationFinancialValues;
  selectedQuotationFinancialValue!: QuotationEditFinalValues;
  public applyLeaseLine: number = 0;
  public planType: number = 0;
  //Formulario de los valores financieros en Quotation
  financialValuesGroup!: FormGroup;

  isChecked = false;
  colummNum = 3;
  public subFinancialValues: Subscription | null = null;

  public onCheckboxChange(event: any): void {
    this.isChecked = event.checked;
  }

  constructor(
    private formBuilder: FormBuilder,
    private quotationService: QuotationService,
    private annualInsuranceService: AnnualInsuranceService,
    private insurancePaymentService: InsurancePaymentService,
    private vehicleUseService: VehicleUseService,
    private generalService: GeneralService,
    public dialog: MatDialog,
  ) {
    // se integro una sub para actualizar el formulario con escuchas de un componente hermano
    this.subFinancialValues = this.quotationService.emitFinancialValues.subscribe((emit) => {
      this.getFinancialValues();
    });
  }

  ngOnDestroy(): void {
    this.subFinancialValues?.unsubscribe();
  }

  ngOnInit(): void {
    if (this.quotationId > 0) {
      this.hasQuotation = true;
    }
    this.quotationFinancialValues = {} as QuotationFinancialValues;
    //Creación del formulario de datos financieros

    this.financialValuesGroup = this.formBuilder.group({
      id: [this.quotationFinancialValues.quotationId],
      costVat: [this.quotationFinancialValues.costVat],
      costDiscount: [this.quotationFinancialValues.costDiscount],
      advanceRent: [this.quotationFinancialValues.advanceRent],
      warrantyRent: [this.quotationFinancialValues.warrantyRent],
      activeInsuranceAmount: [this.quotationFinancialValues.activeInsuranceAmount],
      insurancePayment: [this.quotationFinancialValues.insurancePaymentId],
      annualInsurance: [this.quotationFinancialValues.anualnsuranceAmount],
      vehicleUseId: [this.quotationFinancialValues.vehicleUseId],
      accessoriesFinancedVat: [this.quotationFinancialValues.accessoriesFinancedTotalAmount],
      accessoriesFinancedTotalAmount: [
        this.quotationFinancialValues.accessoriesFinancedTotalAmount,
      ],
      vat: [this.quotationFinancialValues.vat],
      nRate: [this.quotationFinancialValues.nRate],
      nCommission: [this.quotationFinancialValues.commission],
      procedures: [this.quotationFinancialValues.procedures],
      advanceWarrantyRent: [this.quotationFinancialValues.advanceWarrantyRent],
      noContractRatification: [this.quotationFinancialValues.noContractRatification],
      contractRatificationNoVat: [this.quotationFinancialValues.contractRatificationNoVat],
      partialCharge: [this.quotationFinancialValues.partialCharge],
      residualValueAmount: [this.quotationFinancialValues.residualValueAmount],
      residualValuePercentage: [this.quotationFinancialValues.residualValuePercentage],
      fleet: [this.quotationFinancialValues.fleet],
      srs: [this.quotationFinancialValues.srs],
      card: [this.quotationFinancialValues.card],
      segAnualCot: [this.quotationFinancialValues.segAnualCot],
      gpsTipoPago: [this.quotationFinancialValues.gpsTipoPago],
      gpsTotal: [this.quotationFinancialValues.gpsTotal],
      isSegAnual: [this.quotationFinancialValues.isSegAnual == 1 ? true : false],
      applyLeaseLine: [false],
      isOnLeaseLine: [false],
      enganche: [this.quotationFinancialValues.enganche],
      porEnganche: [this.quotationFinancialValues.porEnganche],
    });
  }

  async loadInsurancePayments() {
    this.insurancePayments = await firstValueFrom(
      this.insurancePaymentService.getInsurancePayments(),
    );
  }

  async loadVehicleUses() {
    this.vehicleUses = await firstValueFrom(
      this.vehicleUseService.getVehicles(this.selectedBrand.id, 1),
    );
  }

  async loadAnnualInsurances(insurancePaymentId: number) {
    this.annualInsurances = await firstValueFrom(
      this.annualInsuranceService.getAnnualInsurances(insurancePaymentId, this.quotationId),
    );
  }

  public goToWF() {
    window.parent.location.href = 'https://123leasedynamic.einteligent.com/#/workflow';
  }

  public insurancePayChange(event: any) {
    this.editFinancialData(event.source.id, event.value);
    this.loadAnnualInsurances(event.value);
  }

  public segAnualChange(event: any) {
    this.editFinancialData(event.source.id, event.value);
  }

  public vehicleUseDataChange(event: any) {
    this.editFinancialData(event.source.id, event.value);
  }

  public gpsTipoPagoChange(event: any) {
    this.editFinancialData(event.source.id, event.value);
  }

  public getNumberReponse(value: any) {
    const answer = value ? '1' : '0';
    return answer;
  }

  public onChangeEarlyRentData(event: any) {
    var quotationEditoModel = {
      quotationId: this.quotationId,
      field: event.source.name,
      value: this.getNumberReponse(event.checked),
    };
    this.changeFinancialConditionQuotation(quotationEditoModel);
  }

  public onChangenonNumtoString(event: any) {
    const lowerFirst = event.target.name.charAt(0).toLowerCase() + event.target.name.slice(1);
    var quotationEditoModel = {
      quotationId: this.quotationId,
      field: event.target.name,
      value: String(this.financialValuesGroup.value[lowerFirst]),
    };
    this.changeFinancialConditionQuotation(quotationEditoModel);
  }

  public onChangenoContractRatificationData(event: any) {
    var quotationEditoModel = {
      quotationId: this.quotationId,
      field: event.source.name,
      value: this.getNumberReponse(event.checked),
    };
    this.changeFinancialConditionQuotation(quotationEditoModel);
  }

  public onBlurCost(event: any) {
    const rawValue = event.target.value;
    const cleanString = rawValue.replace('$', '').replace(/,/g, '');
    const finalNumber = Number(cleanString) || 0;

    this.editFinancialData(event.target.name, finalNumber);
  }

  public onCostValidateNotZero(event: any) {
    const rawValue = event.target.value;
    const cleanString = rawValue.replace('$', '').replace(/,/g, '');
    const finalNumber = Number(cleanString) || 0;

    if (finalNumber > 0) {
      this.editFinancialData(event.target.name, finalNumber);
    } else {
      event.target.value = '$1';
      this.editFinancialData(event.target.name, 1);
      this.generalService.viewSnacAlert(
        'No puedes usaer $0 en este campo',
        'alert',
        'Valor no permitido',
      );
    }
  }

  //financing y others
  async editFinancialValuesDataWithoutFields() {
    if (!this.hasQuotation) {
      this.selectedDeadline = { id: 0, description: 'nada' };
    }
    if (this.loadDeadLineCompare().length != 0 && this.loadCoveragesCompare().length != 0) {
      this.quotationComparatives = await firstValueFrom(
        this.quotationService.compareQuotation(
          this.quotationId,
          this.loadDeadLineCompare(),
          this.loadCoveragesCompare(),
        ),
      );
    } else {
      this.quotationComparatives = [];
    }
    this.sendToComparative();
  }

  async UpdateQuotationComparative() {
    this.getFinancialValues();
    this.quotationComparatives = await firstValueFrom(
      this.quotationService.compareQuotation(
        this.quotationId,
        this.loadDeadLineCompare(),
        this.loadCoveragesCompare(),
      ),
    );
    this.sendToComparative();
  }

  public sendToComparative() {
    // reinicio del componente comparativo
    this.comparativeComponentReturn.emit();
  }

  public editFinancialData(field: string, value: any) {
    const lowerFirst = field.charAt(0).toLowerCase() + field.slice(1);
    var quotationEditoModel = {
      quotationId: this.quotationId,
      field: field,
      value: this.financialValuesGroup.value[lowerFirst]
        ? this.financialValuesGroup.value[lowerFirst]
        : value,
    };
    this.changeFinancialConditionQuotation(quotationEditoModel);
  }

  public changeFinancialConditionQuotation(body: QuotationEditModel) {
    this.quotationService.changeFinancialConditionQuotation(body).subscribe(async (data) => {
      if (data) {
        this.getFinancialValues();
        this.sendToComparative();
      }
    });
  }

  public loadDeadLineCompare() {
    this.deadLinesCompare = [];
    this.selectedDeadLines.forEach((deadLine) => {
      var quotationDeadLine: QuotationCompareDeadLines = { deadLineIds: deadLine.id };
      this.deadLinesCompare.push(quotationDeadLine);
    });
    return this.deadLinesCompare;
  }

  public loadCoveragesCompare() {
    this.coveragesCompare = [];
    this.selectedCoverages.forEach((coverage) => {
      var quoationCoverage: QuotationCompareCoverages = { coverageIds: coverage.id };
      this.coveragesCompare.push(quoationCoverage);
    });
    return this.coveragesCompare;
  }

  async getFinancialValues() {
    const financialValues: QuotationFinancialValues = await firstValueFrom(
      this.quotationService.getQuotationFinancialValues(this.quotationId),
    );

    this.applyLeaseLine = financialValues.applyLeaseLine;
    this.planType = financialValues.tipoPlan ?? 0;
    this.financialValuesGroup.patchValue({
      costVat: financialValues.costVat,
      costDiscount: financialValues.costDiscount,
      advanceRent: financialValues.advanceRent,
      warrantyRent: financialValues.warrantyRent,
      insurancePayment: financialValues.insurancePaymentId,
      annualInsurance: financialValues.anualnsuranceAmount,
      vehicleUseId: financialValues.vehicleUseId,
      accessoriesFinancedVat: financialValues.accessoriesFinancedVat,
      accessoriesFinancedTotalAmount: financialValues.accessoriesFinancedTotalAmount,
      vat: financialValues.vat,
      nRate: financialValues.nRate,
      nCommission: financialValues.commission,
      procedures: financialValues.procedures,
      advanceWarrantyRent: financialValues.advanceWarrantyRent,
      noContractRatification: financialValues.noContractRatification,
      contractRatificationNoVat: financialValues.contractRatificationNoVat,
      partialCharge: financialValues.partialCharge,
      residualValueAmount: financialValues.residualValueAmount,
      residualValuePercentage: financialValues.residualValuePercentage,
      fleet: financialValues.fleet,
      srs: financialValues.srs,
      card: financialValues.card,
      segAnualCot: financialValues.segAnualCot,
      activeInsuranceAmount: financialValues.activeInsuranceAmount,
      gpsTipoPago: financialValues.gpsTipoPago,
      gpsTotal: financialValues.gpsTotal,
      isSegAnual: financialValues.isSegAnual == 1 ? true : false,
      applyLeaseLine: financialValues.applyLeaseLine,
      isOnLeaseLine: financialValues.isOnLeaseLine == 1 ? true : false,
      enganche: financialValues.enganche,
      porEnganche: financialValues.porEnganche,
    });

    var insurancePaymentId = financialValues.insurancePaymentId;
    this.loadAnnualInsurances(insurancePaymentId);
  }

  public onLeaseLine(isChecked: boolean) {
    const quotationEditoModel = {
      quotationId: this.quotationId,
      field: 'IsOnLeaseLine',
      value: this.getNumberReponse(isChecked),
    };

    this.changeFinancialConditionQuotation(quotationEditoModel);
  }
  public onAnnualInsurance(event: boolean) {
    this.quotationService
      .annualInsurance(this.quotationId, { isAnnualInsurance: event })
      .subscribe((data) => {
        this.editFinancialData('SegAnualCot', this.financialValuesGroup.value.segAnualCot);
      });
  }
}
